import axios from "axios";

export const getEmailTextModels = lng => {
  const requestUrl = `/mailing/text-model`;
  let filter = [];

  filter.push({
    property: "targetApp",
    value: "ACCOUNTING",
    operator: "eq"
  });
  filter.push({
    property: "language",
    value: lng,
    operator: "eq"
  });

  let params = {};

  params.filter = JSON.stringify(filter).replace(
    /SPECIAL_CHAR_TO_REPLACE/g,
    "\\"
  );

  return axios.get(requestUrl, { params });
};

export const getEmailRecipients = uen => {
  const requestUrl = `/data/recipients`;
  let params = {
    organization: uen
  };

  return axios.get(requestUrl, { params });
};

export const getPresentationEmailHistory = (target, owner, period) => {
  const requestUrl = `/data/presentation/email-history`;
  let params = {
    target,
    owner,
    period
  };

  return axios.get(requestUrl, { params });
};

export const savePresentationEmailHistory = (
  owner,
  target,
  recipient,
  modelCode,
  year
) => {
  const requestUrl = `/data/presentation/email-history/save`;

  let formData = new FormData();
  formData.append("owner", owner);
  formData.append("target", target);
  formData.append("model", modelCode);
  formData.append("recipient", JSON.stringify(recipient));
  formData.append("period", year);

  return axios.post(requestUrl, formData);
};

export const sendPresentationEmail = (
  recipients,
  type,
  lng,
  dynamicFields,
  organization,
  files
) => {
  const requestUrl = `/mailing/generic-email/send`;
  let formData = new FormData();
  formData.append("recipients", JSON.stringify(recipients));
  formData.append("app", "ACCOUNTING");
  formData.append("type", type);
  formData.append("language", lng);
  formData.append("dynamicFields", JSON.stringify(dynamicFields));
  formData.append("organization", organization);
  if (type === "APPOINTMENT") {
    for (let i = 0; i < files.length; i++) {
      formData.append(`file[${i}]`, files[i], files[i].name);
    }
  }

  return axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/emailing.js